/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */


import { RoutePath } from '@/main/routes/constants/routesConstants';
import { stringFormatParams } from '@/main/utils/stringFormat';

import { EFastActionsButtonTypes } from './constants/constants';
import { IFastActionsTranslation } from './types/fastActionsTypes';


interface IModalTextToButtonsProps {
    translation: IFastActionsTranslation;
    buttonType: EFastActionsButtonTypes;
}

export const ModalTextToButtons = ({ translation, buttonType }: IModalTextToButtonsProps) => {
    const accountLinkText = stringFormatParams(translation.fastActionsModals.accountLinkText, {
        accountsLink: RoutePath.account,
    });
    const subscribersLinkText = stringFormatParams(translation.fastActionsModals.subscribersLinkText, {
        subscribersLink: RoutePath.subscriberMobile,
    })
    switch (buttonType) {
        case EFastActionsButtonTypes.INQUIRY_CREATE:
            return stringFormatParams(translation.fastActionsModals.createInquiry.text, {
                accounts: accountLinkText,
                subscribers: subscribersLinkText,
            });
        case EFastActionsButtonTypes.BILL_INVOICE:
            return stringFormatParams(translation.fastActionsModals.bills.text, {
                accounts: accountLinkText,
            });
        case EFastActionsButtonTypes.REPORT_DOCUMENTS:
            return stringFormatParams(translation.fastActionsModals.documents.text, {
                accounts: accountLinkText,
            });
        case EFastActionsButtonTypes.ADVANCE_INVOICE:
            return stringFormatParams(translation.fastActionsModals.advanceAccount.text, {
                accounts: accountLinkText,
            });
        case EFastActionsButtonTypes.PROMISED_PAYMENTS:
            return stringFormatParams(translation.fastActionsModals.addPromicePayment.text, {
                accounts: accountLinkText,
            });
        default:
            return '';
    }
}
